import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthClient } from '../auth/auth.client';

@Injectable()
export class CanActivateEmptyWorkspaceGuard implements CanActivate {
  
  constructor(
    private _authClient: AuthClient,
    private _router: Router) {}

  canActivate() {
    return this._authClient.isEmptyWorkSpace().map((isEmpty) => {
      if(isEmpty) {
        this._router.navigate(['out-of-service']);
      }

      return !isEmpty;
    });
  }
}
